export const useDateConstraints = () => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const tomorrow = new Date(today)
  tomorrow.setDate(today.getDate() + 1)

  const maxStartDate = new Date(today)
  maxStartDate.setDate(today.getDate() + 7)

  const maxEndDate = new Date(today)
  maxEndDate.setMonth(today.getMonth() + 3)

  return {
    tomorrow,
    maxStartDate,
    maxEndDate,
  }
}
